import React from 'react'
import NotFoundPageContent from '@/components/pages/NotFoundPage/NotFoundPageContent'

export default function NotFoundPage() {
    return <NotFoundPageContent />
}
